<div fxLayout="column" *ngIf="isReady()" class="flex-container pt-1" fxFill>
  <!-- <div
    fxLayout="row"
    fxLayout.xs="column"
    fxLayoutAlign="start center"
    fxLayoutAlign.xs="none"
    class="filter-container"
  >
    <div fxFlex fxLayout="row wrap" fxLayoutAlign="end center">
      <div fxFlex="40px">
        <button title="{{ 'public.refresh' | translate }}" mat-icon-button color="black" (click)="refreshList()">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>

      <div fxFlex="auto">
        <mat-form-field class="full-width">
          <mat-select [(ngModel)]="orderBy" (selectionChange)="changeSort($event)" [placeholder]="'Sort by'">
            <mat-option value="name">
              {{ 'sort_by.name' | translate }}
            </mat-option>
            <mat-option value="connected_agents">
              {{ 'sort_by.connected_agents' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div fxFlex="40px">
        <button
          color="black"
          [title]="
            (orderDir ? 'active_outbound_campaign.sort.descending' : 'active_outbound_campaign.sort.ascending')
              | translate
          "
          mat-icon-button
          (click)="changeDirection($event)"
        >
          <mat-icon *ngIf="orderDir">
            <fa-icon [icon]="FAIcons.faSortAlphaDown"></fa-icon>
          </mat-icon>
          <mat-icon *ngIf="!orderDir">
            <fa-icon [icon]="FAIcons.faSortAlphaUp"></fa-icon>
          </mat-icon>
        </button>
      </div>

      <div>
        <flex-search-input
          [placeholder]="'public.button.search' | translate"
          (onInput)="applyFilter()"
          [(ngModel)]="search"
          (ngModelChange)="applyFilter()"
          [hintText]="'active_outbound_campaign.search.hint' | translate"
        >
        </flex-search-input>
      </div>
    </div>
  </div> -->

  <div fxFlex="auto" fxLayout="row" fxLayoutGap="10px" fxLayoutWrap>
    <mat-checkbox [(ngModel)]="filters.remainingCalls" (change)="applyFilter()">
      {{ 'active_outbound_campaign.filters.campaigns_with_remaining_calls' | translate }}
    </mat-checkbox>
    <mat-checkbox [(ngModel)]="filters.callsToday" (change)="applyFilter()">
      {{ 'active_outbound_campaign.filters.campaigns_with_calls_today' | translate }}
    </mat-checkbox>
    <mat-checkbox [(ngModel)]="filters.noAssignedAgent" (change)="applyFilter()">
      {{ 'active_outbound_campaign.filters.campaigns_with_no_assigned_agent' | translate }}
    </mat-checkbox>
    <mat-checkbox [(ngModel)]="filters.noConnectedAgent" (change)="applyFilter()">
      {{ 'active_outbound_campaign.filters.campaigns_with_no_connected_agent' | translate }}
    </mat-checkbox>
  </div>

  <div fxFlex="auto" fxLayout="row" fxLayoutGap="10px" fxLayoutWrap>
    <div fxFlex>
      <mat-form-field class="full-width flex-select">
        <mat-label>{{ 'stats.filter.select_agent' | translate }}</mat-label>
        <flex-select-user-input
          [excludeTypes]="['watcher', 'user']"
          [multiple]="true"
          [showCheckAll]="true"
          [filteredIds]="filteredUserIds"
          [(ngModel)]="filters.selectedAgents"
          (selectionChange)="applyFilter()"
          [hasUser]="true"
          placeholder="{{ 'stats.filter.select_agent' | translate }}"
        >
        </flex-select-user-input>
  
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="clearAgentValue($event)"
          [disabled]="!filters.selectedAgents || !filters.selectedAgents.length"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

    </div>

    <div fxFlex>
      <mat-form-field class="full-width flex-select">
        <mat-label>{{ 'stats.filter.select_group' | translate }}</mat-label>
        <flex-select-group-input
          [limitedByRole]="true"
          [multiple]="true"
          [showCheckAll]="true"
          [(ngModel)]="filters.selectedGroups"
          (selectionChange)="applyFilter()"
          [filteredIds]="filteredGroupIds"
          [hasAgentOrQueueOrDid]="true"
          groupType="service"
          placeholder="{{ 'stats.filter.select_group' | translate }}"
        >
        </flex-select-group-input>
  
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="clearGroupValue($event)"
          [disabled]="!filters.selectedGroups || !filters.selectedGroups.length"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

    </div>
  </div>

  <mat-tab-group fxFlex="grow" mat-stretch-tabs [selectedIndex]="tabSelectedIndex"
    class="flex-tab-group"
    (selectedTabChange)="onTabChange($event)">
    <mat-tab [label]="'active_outbound_campaign.tab.view_campaign'|translate" class="flex-tab">
      <div class="flex-tab-content">
        <flex-table
          [dataSource]="dataSourceTable"
          [tableConfig]="tableConfigCampaign"
          fxFlex
          fxFill
          class="mt-1"
          [columnTemplates]="{
            processed_percent: tplProcessedPercent,
            name: tplCampaignName,
            result_rate: tplResultRate
          }"
        >
          <ng-template #tplProcessedPercent let-item="row"> {{ item.processed_percent }}% </ng-template>

          <ng-template #tplCampaignName let-item="row">
            <a class="flex-link" href="javascript:void;" (click)="gotoPageCampaign($event, item.id)">{{ item.name }}</a>
          </ng-template>
    
          <ng-template #tplResultRate let-item="row">
            {{ item.success_today_calls }} / {{ item.failure_today_calls }}
          </ng-template>
        </flex-table>
      </div>

    </mat-tab>

    <mat-tab [label]="'active_outbound_campaign.tab.view_group'|translate" class="flex-tab">
      <div class="flex-tab-content">
        <flex-table
          [dataSource]="dataSourceGroup"
          [tableConfig]="tableConfigGroup"
          fxFlex
          fxFill
          class="mt-1"
          [columnTemplates]="{
            processed_percent: tplProcessedPercent,
            name: tplGroupName,
            result_rate: tplResultRate
          }"
        >
          <ng-template #tplProcessedPercent let-item="row"> {{ item.processed_percent }}% </ng-template>

          <ng-template #tplGroupName let-item="row">
            <a class="flex-link" href="javascript:void;" (click)="item.id > 0 && gotoPageGroup($event, item.id)">{{ item.name }}</a>
          </ng-template>
    
          <ng-template #tplResultRate let-item="row">
            {{ item.success_today_calls }} / {{ item.failure_today_calls }}
          </ng-template>
        </flex-table>
      </div>

    </mat-tab>
  </mat-tab-group>

  <!-- <mat-card class="flex-header">
    <mat-card-header>
      <mat-card-title fxLayout="row">
        <div fxFlex="30">
          {{ 'active_outbound_campaign.content.active_campaign'|translate }}
        </div>
        <div>{{ 'campaign.available_agents'|translate }}</div>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div class="campaign-item pt-1" *ngFor="let campaign of displayedCampaigns" fxLayout="row"
        fxLayoutAlign="start start" fxLayoutAlign.xs="start" fxFlexFill fxLayoutGap="5px" fxLayoutGap.xs="0">

        <div fxFlex="30" fxLayout="column">
          <mat-nav-list>
            <h2 mat-subheader class="font-weight-bold">{{ campaign.name }}</h2>
            
            <mat-list-item>
              <div class="full-width">
                <app-flex-progress-line color="success" tooltip="active_outbound_campaign.active_campaign.handled_per_total_calls"
                  [value]="campaign.processed_percent">
                </app-flex-progress-line>
              </div>
            </mat-list-item>

            <mat-list-item>
              <span matLine>{{'active_outbound_campaign.active_campaign.total_calls'|translate}}</span>
              <strong>{{campaign.total_calls}}</strong>
            </mat-list-item>

            <mat-list-item>
              <span matLine>{{'active_outbound_campaign.active_campaign.success_calls'|translate}}</span>
              <strong>{{campaign.success_today_calls}}/{{campaign.success_calls}}</strong>
            </mat-list-item>

            <mat-list-item>
              <span matLine>{{'active_outbound_campaign.active_campaign.failure_calls'|translate}}</span>
              <strong>{{campaign.failure_calls}}</strong>
            </mat-list-item>

            <mat-list-item>
              <span matLine>{{'active_outbound_campaign.active_campaign.remaining_calls'|translate}}</span>
              <strong>{{campaign.remaining_calls}}</strong>
            </mat-list-item>

            <mat-list-item>
              <span matLine>{{ 'active_outbound_campaign.active_campaign.connected_agents'|translate }}</span>
              <strong>{{campaign.connected_agents}}</strong>
            </mat-list-item>

          </mat-nav-list>
        </div>
        <div fxFlex>
          <available-agents [agentSort]="agentSort" [filterQueue]="campaign.queue" [filterUngroupedAgents]="true"
            displayType="compact" callDirection="both">
          </available-agents>
        </div>
      </div>

    </mat-card-content>

  </mat-card> -->
</div>
